<template>
    <div><img v-if="btnFlag" class="go_top" src="../assets/information/up.png" @click="backTop"></div>
</template>
<script>
export default {
    name: 'top',
    data(){
        return {
            btnFlag: false,
        }
    },
    mounted(){
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed(){
        window.addEventListener('scroll', this.scrollToTop)
    },
    methods:{
        backTop(){
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                clearInterval(timer)
                }
            }, 16)
        },
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
                that.btnFlag = true
            } else {
                that.btnFlag = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.go_top{
    width: 62px;
    height: 62px;
    position: fixed;
    right: 12px;
    bottom: 20px;
}
</style>